import { Alert } from 'components/common';
import { useRole, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import React, { useEffect } from 'react'
import { useHistory, withRouter } from 'react-router-dom';
import RoleFormDumb from './RoleFormDumb';

const RoleCreateSmart = () => {

  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);
  const history = useHistory();
  const { cleanUpMessage, error, success, postRole } = useRole();

  const defaultValues = {
    name: '',
    description: '',
    project: projects[0].value,
    permissions: []
  }

  const handleCloseAlert = () => cleanUpMessage();

  const handleCreate = (data) => {
    postRole({
      body: {...data},
    });
  };

  useEffect(() => {
    if (!!success.post) history.push(ROUTES.ROLE_LIST);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);

  return (
    <>
      { projects &&
        <RoleFormDumb
          defaultValues={defaultValues}
          handleOnSubmit={handleCreate}
          isEdit={false}
        />
      }
      <Alert
        severity="error"
        handleClose={handleCloseAlert}
        open={error.post}
        message="common.errors.general.title"
      />
    </>
  );
}

export default withRequest(withRouter(RoleCreateSmart));
